import Api from 'Helpers/api';

const User = {
	get: async () => {
		try {
			const response = await Api.call('get', '/users/me');
			return response.data;
		} catch (err) {
			console.log('user get error', err);
			if (err.statusCode === 401) {
				if (err.message === 'Invalid token.') {
					localStorage.removeItem('token');
					window.location.href = '/login';
				}
			}
			return null;
		}
	},
	login: async (params) => {
		try {
			const response = await Api.call('post', '/auth/local', params);
			return response.data;
		} catch (err) {
			console.log('api response error', err);
			return {
				error: {
					message: err.data[0].messages[0],
					status: err.statusCode,
					error: err.error
				}
			};
		}
	}
};

export default User;
